import React from "react";
import { aboutText, profile } from "../mock";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

const PillarCard = ({ pillar }) => {
  const Icon = Icons[pillar.icon] || Icons.Sparkles;
  return (
    <div className="group relative rounded-2xl p-5 md:p-6 bg-gradient-to-br from-[#a01d3f]/12 via-[#121212] to-[#0f0f0f] border border-[#a01d3f]/35 overflow-hidden transition-all duration-300 hover:border-[#a01d3f] hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(160,29,63,0.55)] cursor-default">
      {/* Decorative bordeaux blur blob */}
      <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-[#a01d3f]/20 blur-3xl pointer-events-none opacity-70 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500" />

      <div className="relative flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#a01d3f] to-[#861732] flex items-center justify-center shrink-0 shadow-[0_4px_14px_-2px_rgba(160,29,63,0.55)] group-hover:shadow-[0_6px_20px_-2px_rgba(160,29,63,0.75)] transition-shadow duration-300">
          <Icon size={16} strokeWidth={1.7} className="text-[#f4f1ea]" />
        </div>
        <h3 className="font-display text-base md:text-lg font-semibold tracking-tight leading-tight">
          {pillar.title}
        </h3>
      </div>
      <p className="relative text-sm text-[#f4f1ea]/72 leading-relaxed">
        {pillar.desc}
      </p>

      {/* Bottom shimmer line on hover */}
      <span className="absolute left-5 right-5 bottom-0 h-px bg-gradient-to-r from-transparent via-[#a01d3f] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
  );
};

const About = () => {
  return (
    <section id="about" className="section-padding bg-[#0a0a0a] text-[#f4f1ea] relative grain overflow-hidden">
      <div
        className="absolute top-1/3 -left-40 w-[500px] h-[500px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(160,29,63,0.06) 0%, transparent 70%)" }}
      />

      <div className="container-x relative">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#a01d3f] mb-6 text-center">
          <span className="text-[#f4f1ea]/40">[ 01 ]</span> &nbsp;—&nbsp; {aboutText.eyebrow}
        </p>

        <h2 className="font-display text-4xl md:text-6xl font-semibold leading-[1] tracking-tight text-center mb-12 md:mb-14">
          About{" "}
<span className="italic font-light text-white">
  Me.
</span>
        </h2>

        <div className="max-w-3xl mx-auto space-y-5 text-base md:text-lg leading-relaxed text-[#f4f1ea]/75 text-center mb-16 md:mb-20">
          {aboutText.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {aboutText.pillars.map((pillar) => (
            <PillarCard key={pillar.title} pillar={pillar} />
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default About;
